///<reference types="@types/googlemaps" />
import 'intersection-observer';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { ApiProvider } from '../providers/api/api';
import { AppAvailability } from '@ionic-native/app-availability';
import { AppState } from '../config/state';
import { AttendPage } from '../pages/attend/attend';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CallNumber } from '@ionic-native/call-number';
import { ConfigProvider } from '../providers/config/config';
import { CoBrochurePage } from '../pages/co-brochure/co-brochure';
import { CoRoamEventlistPage } from '../pages/co-roam-eventlist/co-roam-eventlist';
import { CoRoamPatronlookupPage } from '../pages/co-roam-patronlookup/co-roam-patronlookup';
import { CoRoamPatronsignupPage } from '../pages/co-roam-patronsignup/co-roam-patronsignup';
import { CoRoamRegistrantlookupPage } from '../pages/co-roam-registrantlookup/co-roam-registrantlookup';
import { DatabaseProvider } from '../providers/database/database';
import { DatePicker } from '@ionic-native/date-picker';
import { Deeplinks } from '@ionic-native/deeplinks';
import { DirectivesModule } from '../directives/directives.module';
import { DiscoverPage } from '../pages/discover/discover';
import { EmailComposer } from '@ionic-native/email-composer';
import { ErrorHandler, NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FacebookModule } from 'ngx-facebook';
import { Geolocation } from '@ionic-native/geolocation';
import { GoogleMaps } from '@ionic-native/google-maps';
import { HomePage } from '../pages/home/home';
import { HTTP } from '@ionic-native/http';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InfiniteListModule } from 'angular-infinite-list';
import { InViewportModule } from 'ng-in-viewport';
import { Ionic2RatingModule } from 'ionic2-rating';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { MatButtonModule } from '@angular/material/button';
import { MyApp } from './app.component';
import { NgInviewModule } from 'angular-inport';
import { PopoverModule } from "ng4-popover";
import { Printer } from '@ionic-native/printer';
import { ReservePage } from '../pages/reserve/reserve';
import { ScreenPage } from '../pages/screen/screen';
import { SecurityPage } from '../pages/security/security';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxPaginationModule } from 'ngx-pagination';
import { DpDatePickerModule } from 'ng2-date-picker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { Camera } from '@ionic-native/camera';
// Components
import { AgmCoreModule } from '@agm/core';
import { TypesenseProvider } from '../providers/typesense/typesense';
import { CheckinPage } from '../pages/checkin/checkin';
import { CheckoutPage } from '../pages/checkout/checkout';
import { ClientDetailsProvider } from '../providers/client-details/client-details';
import { CoBibItemPage } from '../pages/co-bib-item/co-bib-item';
import { CoBibItemProvider } from '../providers/co-bib-item/co-bib-item';
import { CoCartPage } from '../pages/co-cart/co-cart';
import { CoEventsBrochureModalPage } from '../pages/co-events-brochure-modal/co-events-brochure-modal';
import { CoEventPopupDetailsPage } from '../pages/co-event-popup-details/co-event-popup-details';
import { CoMapPage } from '../pages/co-map/co-map';
import { CoRoomDetailsPage } from '../pages/co-room-details/co-room-details';
import { EventsProvider } from '../providers/events/events';
import { IlsProvider } from '../providers/ils/ils';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LocationsProvider } from '../providers/locations/locations'; // block component
import { MailProvider } from '../providers/mail/mail';
import { NovelistProvider } from '../providers/novelist/novelist';
import { OverdriveProvider } from '../providers/overdrive/overdrive';
import { PageProvider } from '../providers/page/page';
import { PipesModule } from '../pipes/pipes.module';
import { RenewPage } from '../pages/renew/renew';
import { ReserveProvider } from '../providers/reserve/reserve';
import { SmsProvider } from '../providers/sms/sms';
import { WidgetsProvider } from '../providers/widgets/widgets';
import { PatronProvider } from '../providers/patron/patron';
import { CoCheckoutConfirmPage } from '../pages/co-checkout-confirm/co-checkout-confirm';
import { CoEventsRegisterModalPage } from '../pages/co-events-register-modal/co-events-register-modal';
import { IpcService } from '../providers/ipc/ipc';
import { FilteringProvider } from '../providers/filtering/filtering';
import { ColorConvertProvider } from '../providers/color-convert/color-convert';
import { ListProvider } from '../providers/list/list';
import { SocialMediaSharingProvider } from '../providers/social-media-sharing/social-media-sharing';
import { SocialSharing } from '@ionic-native/social-sharing';
import { CoEventEmailSharePage } from '../pages/co-event-email-share/co-event-email-share';
import { CoLibraryCardPage } from '../pages/co-library-card/co-library-card';
import { CoTcModalPage } from '../pages/co-tc-modal/co-tc-modal';
import { CoPatronLookupResultsPage } from '../pages/co-patron-lookup-results/co-patron-lookup-results';
import { CoPatronDetailsPage } from '../pages/co-patron-details/co-patron-details';
import { ToastAlertsProvider } from '../providers/toast-alerts/toast-alerts';
import { CoPatronFeesPage } from '../pages/co-patron-fees/co-patron-fees';
import { CoLogoutSurveyPage } from '../pages/co-logout-survey/co-logout-survey';
import { ContentCafeProvider } from '../providers/content-cafe/content-cafe';
import { ItemProvider } from '../providers/item/item';
import { LoginProvider } from '../providers/login/login';
import { CoAppSelectorPage } from '../pages/co-app-selector/co-app-selector';
import { CoRoomSelectorPage } from '../pages/co-room-selector/co-room-selector';
import { CoLocationSelectorPage } from '../pages/co-location-selector/co-location-selector';
import { TimeoutFunctionsProvider } from '../providers/timeout-functions/timeout-functions';
import { PrintingProvider } from '../providers/printing/printing';
import { CoFailedItemCheckoutModalPage } from '../pages/co-failed-item-checkout-modal/co-failed-item-checkout-modal';
import { CoCatalogSearchPage } from '../pages/co-catalog-search/co-catalog-search';
import { HidScannerProvider } from '../providers/hid-scanner/hid-scanner';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { AppConfigProvider } from  '../config/provider';
import { SoundsProvider } from '../providers/sounds/sounds';
import { CoNovelistModalPage } from '../pages/co-novelist-modal/co-novelist-modal';
import { TimeoutProvider } from '../providers/timeout/timeout';
import { DigitalItemsProvider } from '../providers/digital-items/digital-items';
import { CoDigitalItemPage } from '../pages/co-digital-item/co-digital-item';
import { OpenLibraryProvider } from '../providers/open-library/open-library';
import { CoPatronSignupInfoModalPage } from '../pages/co-patron-signup-info-modal/co-patron-signup-info-modal';
import { AddressLookupProvider } from '../providers/address-lookup/address-lookup';
import { AutoCompleteModule } from 'ionic2-auto-complete';
import { CoEventCheckinPageModule } from '../pages/co-event-checkin/co-event-checkin.module';
import { CoEventFinderPageModule } from '../pages/co-event-finder/co-event-finder.module';
import { CoSelfcheckAccountPageModule } from '../pages/co-selfcheck-account/co-selfcheck-account.module';
import { CoSelfcheckCheckoutPageModule } from '../pages/co-selfcheck-checkout/co-selfcheck-checkout.module';
import { ComponentsModule } from '../components/components.module';
import { CoLoginComponent } from '../components/co-login/co-login';
import { CoBookScannerPopoverComponent } from '../components/co-book-scanner-popover/co-book-scanner-popover';
import { CoPopoverReserveFilterComponent } from '../components/co-popover-reserve-filter/co-popover-reserve-filter';
import { CoReserveCalendarComponent } from '../components/co-reserve-calendar/co-reserve-calendar';
import { CoPopoverEventsFilterComponent } from '../components/co-popover-events-filter/co-popover-events-filter';
import { CoInterestedPopoverComponent } from '../components/co-interested-popover/co-interested-popover';
import { CoSocialMediaButtonsPopoverComponent } from '../components/co-social-media-buttons-popover/co-social-media-buttons-popover';
import { CoHoldPickupPopoverComponent } from '../components/co-hold-pickup-popover/co-hold-pickup-popover';
import { CoBibHoldingListPopoverComponent } from '../components/co-bib-holding-list-popover/co-bib-holding-list-popover';
import { CoSignOutPopoverComponent } from '../components/co-sign-out-popover/co-sign-out-popover';
import { CoPrintPreviewPopoverComponent } from '../components/co-print-preview-popover/co-print-preview-popover';
import { CoPopoverSearchFilterComponent } from '../components/co-popover-search-filter/co-popover-search-filter';
import { CoDateTimePickerPopoverComponent } from '../components/co-date-time-picker-popover/co-date-time-picker-popover';
import { CoSecurityPopoverComponent } from '../components/co-security-popover/co-security-popover';

import { CoPopoverKeyboardComponent } from '../components/co-popover-keyboard/co-popover-keyboard';
import { CoNgxKeyboardComponent } from '../components/co-ngx-keyboard/co-ngx-keyboard';
import { CoEmailInputComponent } from '../components/co-email-input/co-email-input';
import { CoIframeComponent } from '../components/co-iframe/co-iframe';
import { CoOnlineResourcesWidgetModalComponent } from '../components/co-online-resources-widget-modal/co-online-resources-widget-modal';

import { CoCountdownComponent } from '../components/co-countdown/co-countdown';
import { CoBrochureConfirmSentEmailComponent } from '../components/co-brochure-confirm-sent-email/co-brochure-confirm-sent-email';
import { CoGuestRegisterInputComponent } from '../components/co-guest-register-input/co-guest-register-input';

import { CoAccountListComponent } from '../components/co-account-list/co-account-list';
import { CoSelfcheckCheckinPageModule } from '../pages/co-selfcheck-checkin/co-selfcheck-checkin.module';
import { GlobalErrorHandler } from '../util/error-handler';
// import { Brightness } from '@ionic-native/brightness/ngx';
import { CoBibHoldingListModalPage } from '../pages/co-bib-holding-list-modal/co-bib-holding-list-modal';
import { CoRenewalInformationPopoverComponent } from '../components/co-renewal-information-popover/co-renewal-information-popover';
import { CoBulkAddAttendancePopoverComponent } from '../components/co-bulk-add-attendance-popover/co-bulk-add-attendance-popover';
import { CoRoamLoginComponent } from '../components/co-roam-login/co-roam-login';
import { StaffAuthProvider } from '../providers/staff-auth/staff-auth';
import { LoadingPage } from '../pages/loading/loading';
import { CoReserveReservationsComponent } from '../components/co-reserve-reservations/co-reserve-reservations';
import { CoStaffPinComponent } from '../components/co-staff-pin/co-staff-pin';
import { CoPopoverStaffSignOutComponent } from '../components/co-popover-staff-sign-out/co-popover-staff-sign-out';
import { CoPatronDetailFormPage } from '../pages/co-patron-detail-form/co-patron-detail-form';
import { GoodreadsProvider } from '../providers/goodreads/goodreads';



//provide: APP_INITIALIZER, useFactory: getSettings, deps: [AppConfigProvider], multi: true},
export function getSettings(appConfig: AppConfigProvider) {
  return () => appConfig.getSettings();
}

@NgModule({
  declarations: [
    AttendPage,
    CoBibItemPage,
    CoCartPage,
    SecurityPage,
    ReservePage,
    RenewPage,
    CheckoutPage,
    CheckinPage,
    CoAppSelectorPage,
    CoRoomSelectorPage,
    CoBrochurePage,
    CoCheckoutConfirmPage,
    CoEventsBrochureModalPage,
    CoRoamEventlistPage,
    CoRoamPatronlookupPage,
    CoRoamRegistrantlookupPage,
    CoMapPage,
    CoDigitalItemPage,
    CoEventsRegisterModalPage,
    CoBibHoldingListModalPage,
    CoFailedItemCheckoutModalPage,
    CoEventEmailSharePage,
    CoEventPopupDetailsPage,
    CoLogoutSurveyPage,
    CoPatronDetailsPage,
    CoPatronFeesPage,
    CoPatronSignupInfoModalPage,
    CoRoamEventlistPage,
    CoRoamPatronlookupPage,
    CoRoamPatronsignupPage,
    CoRoamRegistrantlookupPage,
    CoRoomDetailsPage,
    DiscoverPage,
    HomePage,
    MyApp,
    ReservePage,
    ScreenPage,
    LoadingPage,
    SecurityPage,
    CoNovelistModalPage,
  CoLibraryCardPage,
  CoPatronDetailFormPage,
    CoTcModalPage,
    CoPatronLookupResultsPage,
    CoLocationSelectorPage,
    CoCatalogSearchPage,
    CoLoginComponent,
    CoRoamLoginComponent,
    CoPopoverReserveFilterComponent,
    CoRenewalInformationPopoverComponent,
    CoBookScannerPopoverComponent,
    CoReserveCalendarComponent,
    CoPopoverEventsFilterComponent,
    CoInterestedPopoverComponent,
    CoSocialMediaButtonsPopoverComponent,
    CoHoldPickupPopoverComponent,
    CoBibHoldingListPopoverComponent,
    CoSignOutPopoverComponent,
    CoPrintPreviewPopoverComponent,
    CoPopoverSearchFilterComponent,
    CoDateTimePickerPopoverComponent,
    CoSecurityPopoverComponent,

    CoPopoverKeyboardComponent,
    CoBulkAddAttendancePopoverComponent,
    CoNgxKeyboardComponent,
    CoEmailInputComponent,
    CoIframeComponent,
    CoOnlineResourcesWidgetModalComponent,
CoAccountListComponent,
    CoCountdownComponent,
    CoBrochureConfirmSentEmailComponent,
    CoGuestRegisterInputComponent,
    CoPopoverStaffSignOutComponent
    // CoBibCoverComponent
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCTXbOnqxbS0BiF_iX8ieWT-kLRGWL880Q',
    }),
    AgmSnazzyInfoWindowModule,
    BrowserModule,
    DirectivesModule,
    FacebookModule.forRoot(),
    HttpClientModule,
    HttpClientJsonpModule,
    ShareButtonsModule.forRoot(),
    InfiniteListModule,
    InViewportModule.forRoot(),
    Ionic2RatingModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
      scrollAssist: false,
      autoFocusAssist: false
    }),
    IonicModule,
    IonicStorageModule.forRoot(),
    LazyLoadImageModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    MatButtonModule,
    NgInviewModule,
    PipesModule,
    PopoverModule,
    NgxQRCodeModule,
	NgxBarcodeModule,
	NgxPaginationModule,
	VirtualScrollerModule,
	AutoCompleteModule,
    DpDatePickerModule,
    MyDateRangePickerModule,
    CoEventCheckinPageModule,
    CoSelfcheckAccountPageModule,
    CoEventFinderPageModule,
    CoSelfcheckCheckoutPageModule,
    CoSelfcheckCheckinPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    AttendPage,
    CoAppSelectorPage,
    CoRoomSelectorPage,
    CoBibItemPage,
    CoCartPage,
    SecurityPage,
    ReservePage,
    RenewPage,
    CheckinPage,
    CheckoutPage,
    CoBrochurePage,
    CoCheckoutConfirmPage,
    CoEventsBrochureModalPage,
    CoLoginComponent,
    CoPopoverReserveFilterComponent,
    CoBookScannerPopoverComponent,
    CoHoldPickupPopoverComponent,
    CoSocialMediaButtonsPopoverComponent,
    CoPopoverEventsFilterComponent,
    CoBibHoldingListPopoverComponent,
    CoSignOutPopoverComponent,
    CoInterestedPopoverComponent,
    CoPrintPreviewPopoverComponent,
    CoPopoverSearchFilterComponent,
    CoDateTimePickerPopoverComponent,
    CoBulkAddAttendancePopoverComponent,
    CoOnlineResourcesWidgetModalComponent,
CoAccountListComponent,
    CoBrochureConfirmSentEmailComponent,
    CoGuestRegisterInputComponent,

    CoCountdownComponent,
    CoIframeComponent,
    CoEmailInputComponent,
    CoNgxKeyboardComponent,
    CoSecurityPopoverComponent,
    CoRoamLoginComponent,
    CoRenewalInformationPopoverComponent,
    CoReserveCalendarComponent,

    CoPopoverKeyboardComponent,
    CoRoamEventlistPage,
    CoRoamPatronlookupPage,
    CoRoamRegistrantlookupPage,
    CoDigitalItemPage,
    CoEventsRegisterModalPage,
    CoBibHoldingListModalPage,
    CoFailedItemCheckoutModalPage,
    CoLogoutSurveyPage,
    CoMapPage,
    CoPatronDetailsPage,
    CoPatronFeesPage,
    CoPatronSignupInfoModalPage,
    CoRoamEventlistPage,
    CoRoamPatronlookupPage,
    CoRoamPatronsignupPage,
    CoRoamRegistrantlookupPage,
    CoRoomDetailsPage,
    DiscoverPage,
    HomePage,
    MyApp,
    ReservePage,
    ReservePage,
    ScreenPage,
    LoadingPage,
    SecurityPage,
    CoEventPopupDetailsPage,
    CoEventEmailSharePage,
    CoNovelistModalPage,
    CoLibraryCardPage,
    CoPatronDetailFormPage,
	CoTcModalPage,
    CoPatronLookupResultsPage,
    CoLocationSelectorPage,
    CoCatalogSearchPage,
    CoReserveReservationsComponent,
    CoStaffPinComponent,
    CoPopoverStaffSignOutComponent
    // CoBibCoverComponent
  ],
  providers: [
	LoginProvider,
    AppConfigProvider,
    // {provide: APP_INITIALIZER, useFactory: getSettings, deps: [AppConfigProvider], multi: true},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    TypesenseProvider,
    ApiProvider,
    CoBrochurePage,
    AppAvailability,
    AppState,
    CallNumber,
    Camera,
    ClientDetailsProvider,
    // ClientDetailsProvider,
    CoBibItemProvider,
    ConfigProvider,
    ColorConvertProvider,
    DatabaseProvider,
    DatePicker,
    Deeplinks,
    EmailComposer,
    EventsProvider,
    Geolocation,
    GoogleMaps,
    // Brightness,
    HTTP,
    IlsProvider,
    InAppBrowser,
    LaunchNavigator,
    LocationAccuracy,
    LocationsProvider,
    MailProvider,
    NovelistProvider,
    OverdriveProvider,
    PageProvider,
    Printer,
    ReserveProvider,
    ReserveProvider,
    SmsProvider,
    SoundsProvider,
    SplashScreen,
    StatusBar,
    WidgetsProvider,
    PatronProvider,
    IpcService,
    FilteringProvider,
    ColorConvertProvider,
    ListProvider,
    SocialMediaSharingProvider,
    SocialSharing,
    ToastAlertsProvider,
    ContentCafeProvider,
	ItemProvider,
    TimeoutFunctionsProvider,
    PrintingProvider,
    HidScannerProvider,
    AnalyticsProvider,
    SoundsProvider,
    TimeoutProvider,
    DigitalItemsProvider,
    OpenLibraryProvider,
    AddressLookupProvider,
    StaffAuthProvider,
    GoodreadsProvider
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts